import { render, staticRenderFns, recyclableRender, components } from "./order.vue?vue&type=template&id=3a85e87e&scoped=true&"
var renderjs
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order.vue?vue&type=style&index=1&id=3a85e87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85e87e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/order/order.vue"
export default component.exports